import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
export function BonosSection() {
  const bonos = [{
    id: '01',
    emoji: '✅',
    title: 'Guión para Reuniones de Padres',
    desc: 'El documento que más van a usar los docentes. 9 guiones completos para cada tipo de reunión: inicio de ciclo, bajo rendimiento, problemas de conducta, inasistencias, dificultades emocionales, situación de acoso, sospecha de vulneración de derechos, cierre de ciclo y egreso. Guión completo para los 8 tipos de padres difíciles. Frases para situaciones inesperadas. Técnicas de regulación emocional del docente. Checklist pre y post reunión.',
    value: '$15.000'
  }, {
    id: '02',
    emoji: '📋',
    title: 'Checklist de Gestión Administrativa',
    desc: '300+ ítems organizados por momento del año. Checklist de inicio de ciclo (40 ítems). Checklist semanal del docente (25 ítems). Checklist de cierre de bimestre/trimestre (40 ítems). Checklist de evaluación y calificación (25 ítems). Checklist de cierre de ciclo lectivo (50 ítems). Checklist de documentación obligatoria. Planificador mensual 2026 completo. Rúbrica de evaluación genérica editable.',
    value: '$12.000'
  }, {
    id: '03',
    emoji: '📖',
    title: 'Diccionario de Sinónimos Pedagógicos',
    desc: 'El vocabulario que diferencia a un informe mediocre de uno profesional. 800+ sinónimos técnicos para verbos, adjetivos y construcciones. Transformador de lenguaje coloquial a técnico (50 casos). Verbos de logro, proceso y dificultad. Conectores y frases de transición. Adjetivos técnicos por área curricular. Lista de palabras prohibidas y sus reemplazos. Guía de estilo para informes docentes.',
    value: '$10.000'
  }, {
    id: '04',
    emoji: '🎯',
    title: 'Pack de Autoevaluación',
    desc: '20+ instrumentos de autoevaluación listos para usar. Semáforo y carita evaluadora para Nivel Inicial. Autoevaluaciones semanales para 1° a 3° grado. Rúbricas para 4° a 6° grado. Autoevaluaciones de período y egreso para Secundario. Rúbricas de coevaluación entre pares. Diario de aprendizaje semanal. Portfolio de aprendizaje. Guía de implementación para el docente.',
    value: '$8.000'
  }];
  return <section className="py-20 bg-black text-white relative overflow-hidden" data-id="element-20">
      <div className="absolute top-0 right-0 w-64 h-64 bg-violet-500/20 rounded-full blur-3xl" data-id="element-21"></div>
      <div className="absolute bottom-0 left-0 w-64 h-64 bg-purple-700/15 rounded-full blur-3xl" data-id="element-22"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-23">
        <div className="text-center mb-16" data-id="element-24">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-violet-400/20 text-violet-400 mb-6" data-id="element-25">
            <Gift className="w-8 h-8" data-id="element-26" />
          </div>
          <h2 className="md:text-4xl font-extrabold mb-4 text-[24px]" data-id="element-27">
            🎁 4 BONUS ESTRATÉGICOS
          </h2>
          <p className="text-xl text-violet-400 font-bold" data-id="element-28">SIEMPRE INCLUIDOS</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-5xl mx-auto" data-id="element-29">
          {bonos.map((bono, i) => <motion.div key={bono.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="bg-zinc-900/80 border border-violet-900/40 rounded-2xl p-6 flex flex-col h-full relative overflow-hidden group hover:border-violet-500/60 transition-colors" data-id="element-30">
              <div className="absolute top-0 right-0 bg-violet-900/60 text-violet-200 text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-31">
                Bonus {bono.id}
              </div>

              <div className="flex items-start gap-4 mb-4 mt-2" data-id="element-32">
                <div className="text-4xl" data-id="element-33">{bono.emoji}</div>
                <div data-id="element-34">
                  <h3 className="text-xl font-bold text-white leading-tight mb-2" data-id="element-35">
                    {bono.title}
                  </h3>
                  <p className="text-zinc-300 text-sm leading-relaxed" data-id="element-36">
                    {bono.desc}
                  </p>
                </div>
              </div>

              <div className="mt-auto pt-4 border-t border-violet-900/30 flex items-center justify-between" data-id="element-37">
                <span className="text-zinc-500 line-through text-sm" data-id="element-38">
                  Valor {bono.value}
                </span>
                <span className="text-violet-400 font-black tracking-wide" data-id="element-39">
                  GRATIS
                </span>
              </div>
            </motion.div>)}
        </div>

        <div className="mt-12 text-center" data-id="element-40">
          <div className="inline-block bg-white/10 backdrop-blur-sm border border-violet-400/30 rounded-xl px-8 py-4" data-id="element-41">
            <p className="text-lg" data-id="element-42">
              Valor total bonos{' '}
              <span className="line-through opacity-50" data-id="element-43">$45.000</span>{' '}
              <span className="text-violet-400 font-bold mx-2" data-id="element-44">→</span>{' '}
              <span className="font-black text-xl" data-id="element-45">GRATIS con tu MegaPack</span>
            </p>
          </div>
        </div>
      </div>
    </section>;
}